// src/i18n/get-translation.js
import * as R from "ramda";

export const getTranslation = (key, lang, dict) => {
  const path = key.split(".");
  return (
    R.path([...path, lang], dict) || R.path([...path, "en"], dict) || `[${key}]`
  );
};

export const pruneUserTranslations = (userDict = {}, defaultDict = {}) => {
  const pruned = {};

  R.toPairs(userDict).forEach(([category, terms]) => {
    const defaultTerms = defaultDict[category];
    if (!defaultTerms) return;

    const filtered = R.pick(R.keys(defaultTerms), terms);
    if (Object.keys(filtered).length > 0) {
      pruned[category] = filtered;
    }
  });

  return pruned;
};

export const mergeTranslations = (defaultDict, userDict = {}) => {
  const { flat: base, categories } = flattenTranslations(defaultDict);
  const { flat: user } = flattenTranslations(userDict);

  const merged = R.mergeWith(R.mergeRight, base, user);
  merged._categories = categories;

  return merged;
};

export const flattenTranslations = (nested) => {
  const flat = {};
  const categories = {};

  R.toPairs(nested).forEach(([category, terms]) => {
    R.toPairs(terms).forEach(([key, translations]) => {
      flat[key] = translations;
      categories[key] = category;
    });
  });

  return { flat, categories };
};

export const getCategoryForKey = (key, defaultDict) => {
  return (
    R.pipe(
      R.toPairs,
      R.find(([, terms]) => R.has(key, terms)),
      R.prop(0)
    )(defaultDict) || "uncategorised"
  );
};
